import { useEffect, useState } from 'react';

export interface SocialLink {
  id: string;
  platform: string;
  url: string;
  displayText?: string;
  iconName?: string;
  displayOrder: number;
  isActive: boolean;
}

export function useSocialLinks() {
  const [links, setLinks] = useState<SocialLink[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let isMounted = true;

    const fetchLinks = async () => {
      try {
        const response = await fetch('/api/social-links', { cache: 'no-store' });
        if (!response.ok) {
          throw new Error(`Failed to fetch social links: ${response.status}`);
        }

        const data = await response.json();
        if (isMounted) {
          setLinks(Array.isArray(data) ? data : []);
        }
      } catch (err) {
        console.error('Error loading social links:', err);
        if (isMounted) {
          setError(err instanceof Error ? err : new Error('Unknown error'));
          setLinks([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchLinks();

    return () => {
      isMounted = false;
    };
  }, []);

  return { links, loading, error };
}

export function findSocialLink(links: SocialLink[], platform: string) {
  const normalizedPlatform = platform.toUpperCase();
  return links.find((link) => link.platform.toUpperCase() === normalizedPlatform);
}
